export const _checkAuth = (token: string) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/check-auth`,
    { method: "GET", headers: { Authorization: `Bearer ${token}` } }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const _user = (id: string, token: string) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/users/${id}`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const _login = (email: string, password: string) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/login`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const getForgotPassword = (input: any) => {
  const reqestURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/forgot-password`;
  const reqestHeader = {
    "Content-Type": "application/json",
  };

  return fetch(reqestURL, {
    method: "POST",
    headers: reqestHeader,
    body: JSON.stringify(input),
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getResetPassword = (input: any) => {
  const reqestURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/reset-password`;
  const reqestHeader = {
    "Content-Type": "application/json",
  };

  return fetch(reqestURL, {
    method: "POST",
    headers: reqestHeader,
    body: JSON.stringify(input),
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
